<template>
  <div class="main-wrapper" v-if="clouds">
    <el-form :inline="true" :model="formInline">
      <el-form-item label="时间：从">
        <el-date-picker v-model="formInline.dateFrom" type="date" placeholder="选择开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker v-model="formInline.dateTo" type="date" placeholder="选择结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="排序">
        <el-switch v-model="formInline.orderByIdDesc" active-text="按创建时间" inactive-text="按到期时间"></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="btnSearchClick">查询</el-button>
        <el-button type="primary" @click.prevent="btnAddClick">新建云助手</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="clouds" style="width: 100%">
      <el-table-column label="用户名">
        <template #default="scope">
          <el-link type="primary" :underline="false" @click.prevent="btnCountClick(scope.row)">
            {{ scope.row.userName }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="手机" width="140" align="center">
        <template #default="scope">
          {{ scope.row.mobile }}
        </template>
      </el-table-column>
      <el-table-column label="云助手类型" width="140" align="center">
        <template #default="scope">
          <el-link
            v-if="scope.row.cloudType !== 'Free'"
            :type="isExpiration(scope.row) ? 'danger' : 'success'"
            :underline="false"
          >
            {{ getCloudType(scope.row) }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140" align="center">
        <template #default="scope">
          {{ scope.row.createdDate }}
        </template>
      </el-table-column>
      <el-table-column label="到期时间" width="140" align="center">
        <template #default="scope">
          <el-link
            v-if="scope.row.cloudType !== 'Free'"
            :type="isExpiration(scope.row) ? 'danger' : 'success'"
            :underline="false"
          >
            {{ scope.row.expirationDate }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template #default="scope">
          <div class="actions">
            <el-link type="primary" :underline="false" @click.prevent="btnEditClick(scope.row)">编 辑</el-link>
            <el-link type="danger" :underline="false" @click.prevent="btnDeleteClick(scope.row)">删 除</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-row style="margin: 10px">
      <el-col :span="24" align="center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="formInline.currentPage"
          :page-size="formInline.limit"
          layout="total, prev, pager, next, jumper"
          :total="count"
        ></el-pagination>
      </el-col>
    </el-row>

    <el-drawer title="用量统计" direction="rtl" size="60%" v-model="isCount">
      <el-row :gutter="20">
        <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
          用户名：<el-tag type="primary">{{ cloud.userName }}</el-tag>，版本：<el-tag type="primary">{{ getCloudType(cloud) }}</el-tag>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <template v-for="count in counts" :key="count.product">
          <el-col :sm="12" :lg="6" v-if="count.maxCount > 0" style="text-align: center; font-size: 14px; padding: 20px">
            <div style="font-size: 16px; margin: 20px 0">
              {{ getCloudProduct(count.product) }}
              <br />
              用量：{{ count.count }}/{{ count.maxCount }}（{{ count.unit }}）
            </div>
            <el-progress type="circle" :percentage="((count.count / count.maxCount) * 100).toFixed(2)" :color="colors"></el-progress>
          </el-col>
        </template>
      </el-row>

      <el-divider></el-divider>

      <div class="el-dialog__footer">
        <el-button @click="isCount = false">关 闭</el-button>
      </div>
    </el-drawer>

    <el-drawer title="新建云助手" direction="rtl" size="60%" v-model="isAdd">
      <el-form style="margin: 0 30px" ref="addForm" :model="addForm" label-position="top">
        <el-form-item label="用户名" prop="userName" :rules="{ required: true, message: '请输入用户名' }">
          <el-input v-model="addForm.userName" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="云助手类型" prop="cloudType" :rules="{ required: true, message: '请选择云助手类型' }">
          <el-radio-group v-model="addForm.cloudType">
            <el-radio label="Free">免费版</el-radio>
            <el-radio label="Standard">标准版</el-radio>
            <el-radio label="Professional">专业版</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="到期时间" prop="expirationDate" :rules="{ required: true, message: '请选择到期时间' }">
          <el-date-picker v-model="addForm.expirationDate" type="date" placeholder="选择到期时间"></el-date-picker>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnAddSubmitClick">确 定</el-button>
          <el-button @click="isAdd = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer title="编辑云助手" direction="rtl" size="60%" v-model="isEdit">
      <el-form style="margin: 0 30px" ref="editForm" :model="editForm" label-position="top">
        <el-form-item label="用户名">
          {{ cloud.userName }}
        </el-form-item>
        <el-form-item label="到期时间" prop="expirationDate" :rules="{ required: true, message: '请选择到期时间' }">
          <el-date-picker v-model="editForm.expirationDate" type="date" placeholder="选择到期时间"></el-date-picker>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnEditSubmitClick">确 定</el-button>
          <el-button @click="isEdit = false">取 消</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script lang="ts">
import utils from '@/utils';
import { defineComponent } from 'vue';
import { ICloud } from '@/types/models';
import api, { IAddRequest, ICloudProductCount, IEditRequest, IGetRequest } from '@/api/admin/clouds';
import { IElForm } from '@/types/element';
import { CloudType } from '@/types/enums';

interface IState {
  count: number;
  clouds: ICloud[];
  cloud: ICloud;
  formInline: IGetRequest;
  isCount: boolean;
  counts: ICloudProductCount[];
  colors: { color: string; percentage: number }[];
  isAdd: boolean;
  addForm: IAddRequest;
  isEdit: boolean;
  editForm: IEditRequest;
}

export default defineComponent({
  data() {
    return {
      count: 0,
      clouds: [],
      cloud: {} as ICloud,
      formInline: {
        cloudType: '',
        currentPage: 1,
        offset: 0,
        limit: 30,
        dateFrom: '',
        dateTo: '',
        orderByIdDesc: false,
      } as IGetRequest,
      isCount: false,
      counts: [],
      colors: [
        { color: '#5cb87a', percentage: 30 },
        { color: '#1989fa', percentage: 50 },
        { color: '#6f7ad3', percentage: 65 },
        { color: '#e6a23c', percentage: 80 },
        { color: '#f56c6c', percentage: 100 },
      ],
      isAdd: false,
      addForm: {} as IAddRequest,
      isEdit: false,
      editForm: {} as IEditRequest,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(this.formInline, (res) => {
        this.count = res.count;
        this.clouds = res.clouds;
      });
    },

    getCloudType(cloud: ICloud) {
      return utils.getCloudType(cloud.cloudType);
    },

    getCloudProduct(product: string) {
      return utils.getCloudProduct(product);
    },

    isExpiration(cloud: ICloud): boolean {
      const date = new Date();
      date.setDate(date.getDate() + 15);
      const expirationDate = new Date(cloud.expirationDate);
      return expirationDate.getTime() <= date.getTime();
    },

    btnCloudClick(cloud: ICloud) {
      this.cloud = cloud;
    },

    btnDeleteClick(cloud: ICloud) {
      utils.alertDelete(
        {
          title: '删除云助手',
          text: `此操作将删除云助手 ${cloud.userName}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(cloud.userId, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('云助手删除成功');
          });
        },
      );
    },

    btnSearchClick() {
      this.apiGet();
    },

    btnAddClick() {
      const d = new Date();
      const year = d.getFullYear();
      const month = d.getMonth();
      const day = d.getDate();
      const expirationDate = new Date(year + 1, month, day);
      this.addForm = {
        userName: '',
        cloudType: CloudType.Free,
        expirationDate,
      } as IAddRequest;
      this.isAdd = true;
    },

    btnAddSubmitClick() {
      (this.$refs.addForm as IElForm).validate((valid) => {
        if (valid) {
          api.add(this.addForm, (res) => {
            if (!res) return;
            this.isAdd = false;
            this.apiGet();
            utils.success('云助手添加成功');
          });
        }
      });
    },

    btnCountClick(cloud: ICloud) {
      this.cloud = { ...cloud };
      api.count(
        {
          userId: this.cloud.userId,
        },
        (res) => {
          if (!res) return;

          this.counts = res.counts;
          this.isCount = true;
        },
      );
    },

    btnEditClick(cloud: ICloud) {
      this.cloud = { ...cloud };
      this.editForm = {
        userId: this.cloud.userId,
        expirationDate: this.cloud.expirationDate,
      } as IEditRequest;
      this.isEdit = true;
    },

    btnEditSubmitClick() {
      (this.$refs.editForm as IElForm).validate((valid) => {
        if (valid) {
          api.edit(this.editForm, (res) => {
            if (!res) return;
            this.isEdit = false;
            this.apiGet();
            utils.success('云助手修改成功');
          });
        }
      });
    },

    handleCurrentChange(val: number) {
      this.formInline.currentPage = val;
      this.formInline.offset = this.formInline.limit * (val - 1);

      api.get(this.formInline, (res) => {
        this.count = res.count;
        this.clouds = res.clouds;
        utils.scrollTop();
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
